import * as PropTypes from 'prop-types';
import * as React from 'react';

const RelatedArticleView = ({ article }) =>
  (
    <div className="blog-post-related-article">
      <div className="pb-half">
        <a href={article._links.web.href}>
          <img alt={article.title} src={article.photo} />
        </a>
      </div>
      <a
        href={article._links.web.href}
        className="related-article-title strong"
      >
        {article.title}
      </a>
    </div>
  );

RelatedArticleView.propTypes = {
  article: PropTypes.object.isRequired,
};

export default RelatedArticleView;



// WEBPACK FOOTER //
// ./javascripts/components/articles/related_article_view.jsx